import type { PartnerAgency } from '../../types/agency'

async function json<T>(res: Response): Promise<T> {
  const body = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(body.error || 'Erreur')
  return body.data as T
}

export async function listAgencies(): Promise<PartnerAgency[]> {
  const res = await fetch('/api/agencies', { credentials: 'include' })
  return json<PartnerAgency[]>(res)
}

export async function createAgency(name: string): Promise<PartnerAgency> {
  const res = await fetch('/api/agencies', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ name }),
  })
  return json<PartnerAgency>(res)
}
